import { createContext, useContext } from "react";
import type { ReactNode } from "react";
import { toast } from "sonner";

export interface ConfirmOptions {
  title: string;
  description?: string;
  body?: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  pendingLabel?: string;
  variant?: "default" | "destructive";
  onConfirm?: () => void | Promise<unknown>;
}

export interface ConfirmContextValue {
  confirm: (options: ConfirmOptions) => Promise<boolean>;
}

export const ConfirmContext = createContext<ConfirmContextValue | null>(null);

export const useConfirm = () => {
  const context = useContext(ConfirmContext);
  if (!context) {
    throw new Error("ConfirmProvider is missing — wrap your app root with it.");
  }
  return context.confirm;
};

export const withConfirmSuccess = <T,>(
  promise: Promise<T>,
  success: string | ((result: T) => string)
): Promise<T> =>
  promise.then((result) => {
    toast.success(typeof success === "function" ? success(result) : success);
    return result;
  });
